import {
  Component,
  EventEmitter,
  Input,
  OnDestroy, OnInit,
  Output
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {faUser} from '@fortawesome/free-regular-svg-icons';
import {faSignIn} from '@fortawesome/free-solid-svg-icons';
import {FormHandler} from "@iw-shared/form/models/form-handler";
import {Subject} from "rxjs";

@Component({
  selector: 'iw-shared-password-lost',
  templateUrl: './password-lost.component.html',
  styleUrls: ['./password-lost.component.scss']
})
export class PasswordLostComponent implements OnInit, OnDestroy {
  @Output() onValidationSuccess: EventEmitter<{ username: string }> = new EventEmitter<{
    username: string
  }>();
  @Input() formHandler!: FormHandler;
  @Input() sentTo?: string;
  @Input() errorMessage?: string;

  private ngUnsubscribe: Subject<void> = new Subject<void>();


  form: FormGroup = this.fb.group({
    username: ['', [Validators.required]]
  });
  captcha: boolean = false;

  faUser = faUser;
  faSignIn = faSignIn;

  constructor(private fb: FormBuilder) {

  }

  ngOnInit(): void {

  }

  isFormKeyInvalid(key: string, displayIfSubmitForm: boolean = true): boolean {
    let form = this.form?.get(key);
    return !!(form?.invalid &&
      (
        this.formHandler.getFormStatus() == 'submitForm' &&
        displayIfSubmitForm
      )
    );
  }

  setCaptcha($event: boolean) {
    setTimeout(() => {
      this.captcha = $event;
    }, 1);

  }

  submit() {
    if (this.form.invalid) {
      this.formHandler.setFormStatus({formStatus: 'submitForm'});
      return;
    }
    if (this.formHandler.getFormStatus() == 'loading') {
      return;
    }
    this.onValidationSuccess.emit({username: this.form.get('username')?.value ?? ''})
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
